import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { SwitchStyleCaseAttributes } from "../Components/Elements/Styles/SwitchStyle";

/**
 * SwitchElement class is class which creates holder for other elements and holds cases which can change children by switching cases.
 * Can be defined only with SwitchStyle (See SwitchStyle class).
 * Default case is NONE.
 * Example 1:
 *   <SwitchElement Class="SwitchElement" Style="SwitchStyle" />
 *
 * @class SwitchElement
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class SwitchElementExtended extends SwitchElement {
    public getTimerDurationByCase(caseType: string): number {
        if (this.style == null || this.style.cases == null) {
            return 0;
        }

        if (!this.hasCase(caseType)) {
            return 0;
        }

        const node: Element = this.style.cases[caseType];

        if (node == null) {
            return 0;
        }

        if (node.hasAttribute(SwitchStyleCaseAttributes.TIMER)) {
            return parseInt(node.getAttribute(SwitchStyleCaseAttributes.TIMER));
        }

        return 0;
    }

    clone(): SwitchElementExtended {
        const element: SwitchElementExtended = new SwitchElementExtended();

        element.style = this.style;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;

        element.elements = this.elements.clone();
        element.addChild(element.elements);

        element.case = this.case;

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SwitchElementExtended.ts
 **/